module.exports = __webpack_public_path__ + "static/media/spring-pat.61659a72.jpg";